// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix =
  'vote/2022project/q2/2022college_questions/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getList = (workType: any, page: any) => {
  return http.get(`${urlPrefix}vote-list&workType=${workType}&page=${page}`);
};

const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail&id=${id}`);
};

export { getBaseInfo, getList, getDetail };
